import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.element.querySelectorAll("pre").forEach((pre) => {
      this._addCopyButton(pre)
    })
  }

  _addCopyButton(pre) {
    const wrapper = document.createElement("div")
    wrapper.className = "relative"
    pre.parentNode.insertBefore(wrapper, pre)
    wrapper.appendChild(pre)

    const button = document.createElement("button")
    button.type = "button"
    button.className = "absolute top-2 right-2 bg-white/10 hover:bg-white/20 text-white/70 hover:text-white p-1.5 rounded transition-colors cursor-pointer"
    button.innerHTML = `
      <span class="default-text"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path></svg></span>
      <span class="copied-text hidden text-green-400"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg></span>
    `
    button.addEventListener("click", () => this._copy(button, pre))
    wrapper.appendChild(button)
  }

  _copy(button, pre) {
    const text = pre.querySelector("code")?.innerText ?? pre.innerText
    navigator.clipboard.writeText(text).then(() => {
      button.querySelector(".default-text").classList.add("hidden")
      button.querySelector(".copied-text").classList.remove("hidden")
      setTimeout(() => {
        button.querySelector(".default-text").classList.remove("hidden")
        button.querySelector(".copied-text").classList.add("hidden")
      }, 2000)
    }).catch(err => console.error("Failed to copy:", err))
  }
}
